// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkbox_checkboxWrapper__8bzSk","checkboxAddonWrapper":"checkbox_checkboxAddonWrapper__wEcYR"};